import { UtilsMisc } from '../../utils/utils.misc';
import { ConfigAuth, IConfigAuth } from './config.auth';
import { ConfigCommChannel, IConfigCommChannel } from './config.comm.channel';
import { ConfigData, IConfigData } from './config.data';
import { ConfigGeoData, IConfigGeoData } from './config.geo.data';
import { ConfigLogging, IConfigLogging } from './config.logging';
import { ConfigSystem, IConfigSystem } from './config.system';

export interface IConfigCore {

    configAuth: IConfigAuth;
    configCommChannel: IConfigCommChannel;
    configData: IConfigData;
    configGeoData: IConfigGeoData;
    configLogging: IConfigLogging;
    configSystem: IConfigSystem;

}

// @dynamic
export class ConfigCore {

    public static get configAuth(): IConfigAuth {
        return ConfigAuth;
    }

    public static get configCommChannel(): IConfigCommChannel {
        return ConfigCommChannel;
    }

    public static get configData(): IConfigData {
        return ConfigData;
    }

    public static get configGeoData(): IConfigGeoData {
        return ConfigGeoData;
    }

    public static get configLogging(): IConfigLogging {
        return ConfigLogging;
    }

    public static get configSystem(): IConfigSystem {
        return ConfigSystem;
    }

    public static assign(source: IConfigCore): void {
        if (UtilsMisc.isNullOrUndefinedOrEmpty(source) === false) {
            ConfigAuth.assign(source.configAuth);
            ConfigCommChannel.assign(source.configCommChannel);
            ConfigData.assign(source.configData);
            ConfigGeoData.assign(source.configGeoData);
            ConfigLogging.assign(source.configLogging);
            ConfigSystem.assign(source.configSystem);
        }
    }

}
